import http from './http';
import { transformAttachment } from './attachments';

const importGoogleDriveFile = (cardId, fileId, requestId, headers) =>
  http
    .post(`/integrations/google/import?requestId=${requestId}`, { cardId, fileId }, headers)
    .then(body => ({
      ...body,
      item: transformAttachment(body.item),
    }));

export default {
  importGoogleDriveFile,
};
